<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qeM7AH/img/1_1.png?1694778366758" alt="This image is the cover for the book Is This America?, The Katrina"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Is This America?, The Katrina
      </h1>
      <p class="bookDescription body article font2">
        <p>From police on the street, to the mayor of New Orleans and FEMA administrators, government officials monumentally failed to protect the most vulnerable residents of New Orleans and the Gulf Coast during the Katrina disaster. This violation of the social contract undermined the foundational narratives and myths of the American nation and spawned a profound, often contentious public debate over the meaning of Katrina’s devastation. A wide range of voices and images attempted to clarify what happened, name those responsible, identify the victims, and decide what should be done. This debate took place in forums ranging from mass media and the political arena to the arts and popular culture, as various narratives emerged and competed to tell the story of Katrina. Is This America? explores how Katrina has been constructed as a cultural trauma in print media, the arts and popular culture, and television coverage. Using stories told by the New York Times, New Orleans Times-Picayune, Time, Newsweek, NBC, and CNN, as well as the works of artists, writers, musicians, filmmakers, and graphic designers, Ron Eyerman analyzes how these narratives publicly articulated collective pain and loss. He demonstrates that, by exposing a foundational racial cleavage in American society, these expressions of cultural trauma turned individual experiences of suffering during Katrina into a national debate about the failure of the white majority in the United States to care about the black minority.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ron Eyerman
      </h2>
      
      <p class="authorDescription body article">RON EYERMANis a professor of sociology and codirector of the Center for Cultural Sociology at Yale University. His previous books include Cultural Trauma: Slavery and the Formation of African American Identity and Narrating Trauma: On the Impact of Collective Suffering.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54db6dea